import { useVisitorSession } from '@/stores/useVisitorSession'

export default defineNuxtRouteMiddleware((to, from) => {
  const visitorSession = useVisitorSession()
  if (!visitorSession.realAdmin) {
    return '/'
  }
})
